webpackJsonp([114276838955818,60335399758886],{

/***/ 155:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(300);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(155);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 1952:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(1952);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	// STYLES
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { id: 'footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 detail-cell hq-social-details' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Connect With Us'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'hq-social-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://www.facebook.com/codefellows.org' },
	                'Facebook'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://twitter.com/CodeFellows' },
	                'Twitter'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://www.linkedin.com/company/code-fellows' },
	                'LinkedIn'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://www.youtube.com/channel/UCbAjy7CL-wn9XuVTvkfD4KQ' },
	                'YouTube'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/meet-the-team/' },
	                'Meet the Team'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 detail-cell hq-information-details' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Learn More'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'hq-social-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.washingtontechnology.org/code-fellows/' },
	                'Scholarship Fund Donations'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/blog/' },
	                'Blog'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/press/' },
	                'Press'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/about/' },
	                'Our Story'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/premier-tech-academy/' },
	                'Premier Tech Academy'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/jobs-at-code-fellows/' },
	                'Careers'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/privacy-policy/' },
	                'Privacy Policy'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 detail-cell hq-contact-details' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Advisors Available'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'hq-social-list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'schedule-list' },
	              'Monday - Friday',
	              _react2.default.createElement('br', null),
	              '6:00 a.m. - 11:00 p.m.',
	              _react2.default.createElement('br', null),
	              'Saturday - Sunday',
	              _react2.default.createElement('br', null),
	              '9:00 a.m. - 5:00 p.m.',
	              _react2.default.createElement('br', null)
	            )
	          ),
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 detail-cell hq-contact-details' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Get in Touch'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'hq-social-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=footer&utm_medium=website&utm_content=footer&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic' },
	                'Apply Now'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'contact-options' },
	                'Call - Text: '
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:2066819318' },
	                '206-681-9318'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'address',
	            { hidden: true, className: 'hq-address' },
	            _react2.default.createElement(
	              'a',
	              {
	                target: '_blank',
	                href: 'https://www.google.com/maps?newwindow=1&biw=1265&bih=786&q=2901+3rd+Ave,+Suite+300+seattle+wa&bav=on.2,or.r_cp.&bvm=bv.117218890,d.cGc&um=1&ie=UTF-8&sa=X&ved=0ahUKEwjM5fvJ4sjLAhVE0WMKHbtCAqAQ_AUIBigB'
	              },
	              '2901 3rd Ave. Suite 300 ',
	              _react2.default.createElement('br', null),
	              'Seattle, WA 98121 ',
	              _react2.default.createElement('br', null)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'social-buttons' },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.facebook.com/codefellows.org', target: '_blank' },
	          _react2.default.createElement('span', { className: 'fb-light' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://twitter.com/codefellows', target: '_blank' },
	          _react2.default.createElement('span', { className: 'tw-light' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.instagram.com/codefellows/', target: '_blank' },
	          _react2.default.createElement('span', { className: 'ig-light' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.linkedin.com/school/2877757', target: '_blank' },
	          '  ',
	          _react2.default.createElement('span', { className: 'li-light' })
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'copyright' },
	        '\xA9\xA0',
	        new Date().getFullYear(),
	        '\xA0Code Fellows, Inc. Code Fellows is a licensed Technical Education provider by the state of Washington.'
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'p',
	        { className: 'copyright', id: 'footer-link' },
	        _react2.default.createElement(
	          'a',
	          { href: '/regulatory-information/' },
	          'Regulatory Information'
	        ),
	        ' | GI Bill\xAE is a registered trademark of the U.S. Department of Veterans Affairs (VA). More information about education benefits offered by VA is available at the official U.S. government Web site at ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.benefits.va.gov/gibill' },
	          'www.benefits.va.gov/gibill'
	        ),
	        '.'
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'p',
	        { className: 'copyright' },
	        'In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, sex, religious creed, disability, age, political beliefs, or reprisal or retaliation for prior civil rights activity in any program or activity conducted or funded by USDA.'
	      )
	    )
	  );
	};
	
	// LIBS
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 1953:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(1953);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // STYLES
	
	
	// LIBS
	
	
	// INTERFACE
	var HeaderNavbar = function (_React$Component) {
	  _inherits(HeaderNavbar, _React$Component);
	
	  function HeaderNavbar(props) {
	    _classCallCheck(this, HeaderNavbar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      display: {
	        'curriculum': 'none',
	        'prospective-students': 'none',
	        'courses': 'none',
	        'partnerships': 'none'
	      }
	    };
	    return _this;
	  }
	
	  HeaderNavbar.prototype.handleClick = function handleClick(event) {
	    event.stopPropagation();
	    var state = this.state;
	    var target = event.target.dataset.target;
	    this._closeDropdowns(target);
	    state.display[target] = state.display[target] === 'block' ? 'none' : 'block';
	    this.setState(state);
	  };
	
	  HeaderNavbar.prototype._closeDropdowns = function _closeDropdowns(keep) {
	    var state = this.state;
	    Object.keys(state.display).map(function (key) {
	      if (key !== keep) state.display[key] = 'none';
	    });
	    this.setState(state);
	  };
	
	  HeaderNavbar.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('click', this._closeDropdowns.bind(this), false);
	  };
	
	  HeaderNavbar.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('click', this._closeDropdowns, false);
	  };
	
	  HeaderNavbar.prototype.render = function render() {
	    return _react2.default.createElement(
	      'ul',
	      { className: 'nav navbar-nav navbar-right' },
	      _react2.default.createElement(
	        'li',
	        { className: 'dropdown', onClick: this.handleClick.bind(this) },
	        _react2.default.createElement(
	          'a',
	          { 'data-target': 'prospective-students', className: 'dropdown-toggle disabled' },
	          'Prospective Students ',
	          _react2.default.createElement('b', { className: 'caret' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'dropdown-menu', style: { display: this.state.display['prospective-students'] } },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/employment-data/' },
	              'Employment Data'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/how-to-apply/' },
	              'How to Apply'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/financing-and-scholarships/' },
	              'Financing & Scholarships'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/get-a-job-in-tech/' },
	              'Career Transition Services'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/tutoring/' },
	              'Tutoring Services'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'dropdown', onClick: this.handleClick.bind(this) },
	        _react2.default.createElement(
	          'a',
	          { 'data-target': 'curriculum', className: 'dropdown-toggle disabled' },
	          'Curriculum ',
	          _react2.default.createElement('b', { className: 'caret' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'dropdown-menu', style: { display: this.state.display['curriculum'] } },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/learn-to-code/' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Software Development'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/code-100/' },
	              '100: Beginner'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/code-201/foundations-of-software-development/' },
	              '200: Foundations'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/code-301/intermediate-software-development/' },
	              '300: Intermediate'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/code-400/' },
	              '400: Advanced'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/code-500/' },
	              '500: Continuing Education'
	            )
	          ),
	          _react2.default.createElement('li', { className: 'divider' }),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/learn-cybersecurity/' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Ops and Cybersecurity'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/ops-100/' },
	              '100: Beginner'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/ops-201/foundations-of-computer-operations/' },
	              '200: Foundations'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/ops-301/networking-and-systems-administration/' },
	              '300: Intermediate'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/ops-400/' },
	              '400: Advanced'
	            )
	          ),
	          _react2.default.createElement('li', { className: 'divider' }),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/learn-web3/' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Web3'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/courses/web3-101/explore-cryptocurrencies-and-web3-careers/' },
	              '100: Beginner'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'dropdown', onClick: this.handleClick.bind(this) },
	        _react2.default.createElement(
	          'a',
	          {
	            'data-target': 'partnerships',
	            className: 'dropdown-toggle disabled'
	          },
	          'Partnerships ',
	          _react2.default.createElement('b', { className: 'caret' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'dropdown-menu', style: { display: this.state.display['partnerships'] } },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/powered-by-code-fellows/' },
	              'Curriculum Licensing'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/employer-partnerships/' },
	              'Employer Services'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/scholarship-fund/' },
	              'Scholarship Fund'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '/course-calendar/' },
	          'Course Calendar'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '/events-calendar/' },
	          'Events'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '/blog/category/testimonials/' },
	          'Testimonials'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '/faq/' },
	          'FAQ'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'btn btn-primary navbar-btn apply_button',
	            style: { paddingTop: '0.5em', paddingBottom: '0.5em' },
	            href: 'https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=header&utm_medium=website&utm_content=header&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic'
	          },
	          'Apply'
	        )
	      )
	    );
	  };
	
	  return HeaderNavbar;
	}(_react2.default.Component);
	
	exports.default = HeaderNavbar;
	module.exports = exports['default'];

/***/ }),

/***/ 1954:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(1954);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerNavbar = __webpack_require__(297);
	
	var _headerNavbar2 = _interopRequireDefault(_headerNavbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // STYLES
	
	
	// LIBS
	
	
	// COMPONENTS
	
	
	// INTERFACE
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    // must use typeof operator to check for window so that gatsby wont crash during
	    // serverside rendering (when window is an undefined var)
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    if (typeof window === 'undefined') {
	      _this.state = { expanded: false };
	    } else {
	      _this.state = { expanded: window.innerWidth > 1200 };
	    }
	    return _this;
	  }
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if (window) {
	      window.addEventListener('resize', function (e) {
	        _this2.setState({ expanded: window.innerWidth > 1200 });
	      });
	    }
	  };
	
	  Header.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'header-container' },
	      _react2.default.createElement(
	        'nav',
	        { id: 'header', className: 'navbar navbar-default', role: 'navigation' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'navbar-header' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'navbar-toggle',
	                onClick: function onClick() {
	                  return _this3.setState(function (state) {
	                    return { expanded: !state.expanded };
	                  });
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                'Toggle navigation'
	              ),
	              _react2.default.createElement('span', { className: 'icon-bar' }),
	              _react2.default.createElement('span', { className: 'icon-bar' }),
	              _react2.default.createElement('span', { className: 'icon-bar' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/', className: 'navbar-brand' },
	              'Code Fellows'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.state.expanded ? _react2.default.createElement(_headerNavbar2.default, null) : undefined
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(1959);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(298);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(296);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	
	
	// COMPONENTS
	// STYLES
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, null),
	    children(),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	// LIBS
	

	module.exports = exports['default'];

/***/ }),

/***/ 1959:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-01e990bf5b1df1d05418.js